import type { JSX } from 'react';
import { MarkerStackDot, ParentDrop } from './MarkerDotCluster.styles';

const PARENT_DROP_PATH = 'M3.49745 8C2.52693 8 1.70139 7.6731 1.02083 7.0193C0.340278 6.3655 0 5.56959 0 4.63158C0 4.21209 0.0769676 3.81092 0.230903 3.42807C0.384838 3.04522 0.607639 2.69786 0.899306 2.38596L2.84047 0.279181C2.93178 0.186628 3.03483 0.116959 3.14964 0.0701754C3.26444 0.0233918 3.38123 0 3.5 0C3.61877 0 3.73556 0.0233918 3.85036 0.0701754C3.96517 0.116959 4.06822 0.186628 4.15953 0.279181L6.10069 2.38596C6.39236 2.69786 6.61516 3.04522 6.7691 3.42807C6.92303 3.81092 7 4.21209 7 4.63158C7 5.56959 6.65887 6.3655 5.97661 7.0193C5.29436 7.6731 4.46797 8 3.49745 8Z';

interface IProps {
  colour: string;
  isLiquidBiopsy: boolean;
  isParent: boolean;
  index: number;
}

/**
 * A single mark within a sample cluster: a Liquid-Biopsy parent renders as the teardrop
 * drop, everything else as a plain stacked dot. Shared by the grouped cluster, the
 * lone-LB row and the hover popup so the teardrop markup lives in one place.
 */
export default function SampleMark({
  colour,
  isLiquidBiopsy,
  isParent,
  index,
}: IProps): JSX.Element {
  if (isLiquidBiopsy && isParent) {
    return (
      <ParentDrop
        className="timeline-marker-drop"
        width="8"
        height="9"
        viewBox="0 0 7 8"
        fill="none"
        aria-hidden="true"
        style={{ marginTop: 0 }}
      >
        <path d={PARENT_DROP_PATH} fill={colour} />
      </ParentDrop>
    );
  }
  return (
    <MarkerStackDot
      className="timeline-marker-dot"
      style={{ background: colour, marginTop: index === 0 ? 0 : undefined }}
    />
  );
}
